import { defineMessages } from 'react-intl';

export const translations = defineMessages({
    customize: {
        id: 'Banner.actions.customize',
        defaultMessage: 'Customize'
    }
});
